import { Controller } from 'stimulus';

/**
 * Toggles the pricing-overrides table between read-only and edit mode.
 * Read-only spans are tagged `readonly`; matching inputs are tagged `editable`.
 * The single Edit button hides itself and reveals the Save / Cancel buttons.
 */
export default class extends Controller {
  static targets = ['readonly', 'editable', 'editBtn', 'saveControls'];

  edit(event) {
    event.preventDefault();
    this.enterEditMode();
  }

  cancel(event) {
    event.preventDefault();
    this.exitEditMode();
  }

  enterEditMode() {
    this.readonlyTargets.forEach((el) => el.classList.add('d-none'));
    this.editableTargets.forEach((el) => el.classList.remove('d-none'));
    this.editBtnTarget.classList.add('d-none');
    this.saveControlsTarget.classList.remove('d-none');
  }

  exitEditMode() {
    this.readonlyTargets.forEach((el) => el.classList.remove('d-none'));
    this.editableTargets.forEach((el) => el.classList.add('d-none'));
    this.editBtnTarget.classList.remove('d-none');
    this.saveControlsTarget.classList.add('d-none');
  }
}
